// Some of the types are not supported by the Web app yet
// As the other will be added, this type will be updated
import { EntityListSourceType, EntityListTypeName } from '@ydistri/api-sdk';
import { AdministrationItemRow } from '../../common/administrationItemsTypes';

import { ImportableItem } from '../../../../lib/imports/importTypes';

export type EntityListTypeSupported =
  | EntityListTypeName.Product
  | EntityListTypeName.Request
  | EntityListTypeName.MinLayer
  | EntityListTypeName.Source
  | EntityListTypeName.Target
  | EntityListTypeName.Forced;

const supportedEntityListTypes = new Set<EntityListTypeName>([
  EntityListTypeName.Product,
  EntityListTypeName.Request,
  EntityListTypeName.MinLayer,
  EntityListTypeName.Source,
  EntityListTypeName.Target,
  EntityListTypeName.Forced,
]);

export const isEntityListTypeSupported = (
  type: EntityListTypeName,
): type is EntityListTypeSupported => supportedEntityListTypes.has(type);

export type AdministrationItemParserFunction<T extends EntityListTypeSupported> = (
  entityListType: T,
  content: string,
  parser?: DOMParser,
) => EntityListRow<T>[];

export interface AdministrationItemParser<T extends EntityListTypeSupported> {
  contentType: string;
  parse: AdministrationItemParserFunction<T>;
}

export interface EntityListProductInputData extends ImportableItem {
  product: string;
}

export interface EntityListSkuInputData extends EntityListProductInputData {
  store: string;
}

export interface EntityListSkuQuantityInputData extends EntityListSkuInputData {
  count: number;
}

export enum EntityListContentItem {
  PRODUCT = 'product',
  STORE = 'store',
  QUANTITY = 'quantity',
}

export interface EntityListTypeMap {
  [EntityListTypeName.Product]: EntityListProductInputData;
  [EntityListTypeName.Request]: EntityListSkuQuantityInputData;
  [EntityListTypeName.MinLayer]: EntityListSkuQuantityInputData;
  [EntityListTypeName.Source]: EntityListSkuInputData;
  [EntityListTypeName.Target]: EntityListSkuInputData;
  [EntityListTypeName.Forced]: EntityListSkuInputData;
  [EntityListTypeName.ForcedToZero]: EntityListSkuInputData;
}

export type EntityListRow<T extends EntityListTypeSupported> = AdministrationItemRow<
  EntityListTypeMap[T]
>;

export type ValidEntityListTypeName = {
  [K in keyof EntityListTypeMap]: EntityListTypeMap[K] extends EntityListProductInputData
    ? K
    : never;
}[keyof EntityListTypeMap];

/**
 * There can be different messages for any action for different entity list types, for example,
 * - content of a request list used in calculation cannot be edited
 *
 * We should display this message at the appropriate place
 */
export interface EntityListCustomMessages {
  nonEditableContentReasons?: string[]; // used in AdministrationItemActions.tsx in editContentButton
}

//export type EntityListItemType = 'Product' | 'Sku' | 'SkuQuantity';

export type EntityListSourceTypeSummary = Record<EntityListSourceType, number>;

export interface EntityListsSummary {
  archivedItemsCount: number;
  sourceTypeCounts: EntityListSourceTypeSummary;
}
